import { ValuationFormValues } from "@/store/valuationFormStore";
import React from "react";
import { useFormContext } from "react-hook-form";


type LocationProps = {
  province: string;
  district: string;
  sector: string;
  cell: string;
  village: string;
  address:string;
  latitude:number;
  longitude:number;
};

const SelectedLocation: React.FC<LocationProps> = ({
  province,
  district,
  sector,
  cell,
  village,
  address,
  latitude,
  longitude
}) => {
  return (
    <div className="mt-6 p-4 bg-gray-50 border border-gray-200 rounded-lg shadow-sm">
      <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center justify-center">
        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
            clipRule="evenodd"
          />
        </svg>
        Location
      </h3>

      <div className="bg-white p-4 rounded-md border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-2 text-sm">
          <div className="text-center p-2 bg-gray-50 rounded">
            <div className="font-medium text-gray-600 text-xs uppercase">
              Province
            </div>
            <div className="text-gray-600 font-semibold">
              {province || "Not selected"}
            </div>
          </div>

          <div className="text-center p-2 bg-gray-50 rounded">
            <div className="font-medium text-gray-600 text-xs uppercase">
              District
            </div>
            <div className="text-gray-600 font-semibold">
              {district || "Not selected"}
            </div>
          </div>

          <div className="text-center p-2 bg-gray-50 rounded">
            <div className="font-medium text-gray-600 text-xs uppercase">
              Sector
            </div>
            <div className="text-gray-600 font-semibold">
              {sector || "Not selected"}
            </div>
          </div>

          <div className="text-center p-2 bg-gray-50 rounded">
            <div className="font-medium text-gray-600 text-xs uppercase">
              Cell
            </div>
            <div className="text-gray-600 font-semibold">
              {cell || "Not selected"}
            </div>
          </div>

          <div className="text-center p-2 bg-gray-50 rounded">
            <div className="font-medium text-gray-600 text-xs uppercase">
              Village
            </div>
            <div className="text-gray-600 font-semibold">
              {village || "Not selected"}
            </div>
          </div>
        </div>

        {province && district && sector && cell && village && (
          <div className="mt-3 pt-3 border-t border-gray-200 flex flex-col justify-center items-center space-y-2">
            <div >
            <p className="text-sm text-gray-600">
              <span className="font-bold">Address:</span>{" "}
              <span className="text-gray-800">
                {address}
              </span>
            </p>
            </div>
            <div>
            <p className="text-sm text-gray-600">
              <span className="font-bold">Coordinates:</span>{" "}
              <span className="text-gray-800">
                ({latitude}, {longitude})
              </span>
            </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectedLocation;

 